var Backbone, RefinementContextLogger,
  extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
  hasProp = {}.hasOwnProperty;

Backbone = require('backbone');

RefinementContextLogger = (function(superClass) {
  extend(RefinementContextLogger, superClass);

  function RefinementContextLogger() {
    return RefinementContextLogger.__super__.constructor.apply(this, arguments);
  }

  RefinementContextLogger.prototype._DEFAULT_CATEGORY = 'goods';

  RefinementContextLogger.prototype._DEFAULT_SORT = 'relevance';

  RefinementContextLogger.prototype._addLoggerEvent = function(event) {
    return OptimizeSuite.TrackingHub.add('deal-card-click', this._getEventMeta(event));
  };

  RefinementContextLogger.prototype._getEventMeta = function(event) {
    return {
      deal: this._getDealInfo(),
      card: this._getCardInfo(event.currentTarget),
      category: this._getCategoryHierarchy(),
      pagination: {
        page: this._getCurrentPageNumber(),
        sort: this._getSort()
      },
      selectedRefinements: this._getRefinements()
    };
  };

  RefinementContextLogger.prototype._getDealInfo = function() {
    return {
      id: this._getDealId(),
      uuid: this._getDealUuid(),
      href: this._getDealHref(),
      categorization: this._getDealCategorization(),
      reviews: this._getDealReviewInfo()
    };
  };

  RefinementContextLogger.prototype._getCardInfo = function(target) {
    return {
      title: this._getCardTitle(target),
      position: this._getCardPosition(target),
      value: this._getCardValue(target),
      price: this._getCardPrice(target),
      reviews: this._getCardReviewInfo(target)
    };
  };

  RefinementContextLogger.prototype._getDealId = function() {
    return null;
  };

  RefinementContextLogger.prototype._getDealUuid = function() {
    return null;
  };

  RefinementContextLogger.prototype._getDealHref = function() {
    return null;
  };

  RefinementContextLogger.prototype._getDealCategorization = function() {
    return [];
  };

  RefinementContextLogger.prototype._getDealReviewInfo = function() {
    return {};
  };

  RefinementContextLogger.prototype._getCardTitle = function() {
    return null;
  };

  RefinementContextLogger.prototype._getCardPosition = function() {
    return null;
  };

  RefinementContextLogger.prototype._getCardValue = function() {
    return null;
  };

  RefinementContextLogger.prototype._getCardPrice = function() {
    return null;
  };

  RefinementContextLogger.prototype._getCardReviewInfo = function() {
    return {};
  };

  RefinementContextLogger.prototype._getSort = function() {
    return this._DEFAULT_SORT;
  };

  RefinementContextLogger.prototype._getCategoryHierarchy = function() {
    return {
      category: this._DEFAULT_CATEGORY,
      id: this._DEFAULT_CATEGORY,
      level: 1
    };
  };

  RefinementContextLogger.prototype._getCurrentPageNumber = function() {
    return 1;
  };

  RefinementContextLogger.prototype._getRefinements = function() {
    return [];
  };

  return RefinementContextLogger;

})(Backbone.View);

module.exports = RefinementContextLogger;

//# sourceMappingURL=data:application/json;base64,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
